import Model, { attr } from '@ember-data/model';

export default class DocumentModel extends Model {
  @attr() documentName;
  @attr() documentExt;
  @attr() thisType;
  @attr('moment') createdAt;
}
